import {
  GET_ASTROUSER,
  GET_ASTROUSER_FAIL,
  GET_ASTROUSER_SUCCESS,
  GET_ASTROUSER_DETAILS,
  GET_ASTROUSER_DETAILS_FAIL,
  GET_ASTROUSER_DETAILS_SUCCESS,               
  CLEAR_ACTION_RESULT
} from "./actionTypes"

export const clearActionResult = () => ({
  type: CLEAR_ACTION_RESULT,
})

export const getAstroUser = (page, size, sortField, sortOrder, search) => ({
  type: GET_ASTROUSER,
  payload: { page, size, sortField, sortOrder, search }
})

export const getAstroUsersSuccess = (userPage) => ({
  type: GET_ASTROUSER_SUCCESS,
  payload: userPage
})

export const getAstroUsersFail = error => ({
  type: GET_ASTROUSER_FAIL,
  payload: error,
})   

export const getAstroUserDetails = () => ({
  type: GET_ASTROUSER_DETAILS,
})

export const getAstroUserDetailsSuccess = user=> ({
  type: GET_ASTROUSER_DETAILS_SUCCESS,
  payload: user,
})

export const getAstroUserDetailsFail = error => ({
  type: GET_ASTROUSER_DETAILS_FAIL,
  payload: error,
})










getAstroUsersFail


















 



















